import * as Sentry from '@sentry/vue';
import { NEWS_API_ENDPOINT, SENTRY_DSN, SENTRY_REPLAYS_SAMPLE_RATE, SENTRY_TRACES_SAMPLE_RATE } from '~/config';

const sentryConfig = {
    dsn: SENTRY_DSN,
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE || 0.1, // Default to 10% if not set
    tracePropagationTargets: [
        NEWS_API_ENDPOINT,
        // EXTENDER_CONTRACTS_API_ENDPOINT,
    ],
    replaysSessionSampleRate: SENTRY_REPLAYS_SAMPLE_RATE || 0.01, // Default to 1% if not set
    replaysOnErrorSampleRate: 1.0,
    // Filter out browser extension errors
    beforeSend(event, hint) {
        const error = hint.originalException;
        if (error && error.message) {
            // Ignore browser extension errors
            if (error.message.includes('chrome-extension://')
                || error.message.includes('moz-extension://')
                || error.message.includes('safari-extension://')) {
                return null;
            }
        }
        return event;
    },
};

export default function registerSentry(Vue, router) {
    if (SENTRY_DSN) {
        Sentry.init({
            Vue,
            integrations: [
                Sentry.browserTracingIntegration({ router }),
            ],
            ...sentryConfig,
        });
    }
}
